import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {types} from '../../providers/data';
import {NgbDropdownConfig} from '@ng-bootstrap/ng-bootstrap';
import {NgxSpinnerService} from 'ngx-spinner';
import {Api} from '../../providers/api';
import {Auth} from '../../providers/auth';
import {EntitlementService} from '../../providers/entitlement.service';
import * as moment from 'moment';

@Component({
  selector: 'app-frame-view',
  templateUrl: './frame-view.component.html',
  styleUrls: ['./frame-view.component.css']
})
export class FrameViewComponent implements OnInit {

  @Output()
  onclose = new EventEmitter();

  @Input()
  frame;

  @Output()
  save = new EventEmitter<any>();

  @Input()
  circuito;

  tipos = types;
  newFrame_nombre;
  newFrame_texto;
  newFrame_path;
  newFrame_idTipo;
  newFrame_segundos;
  newFrame_idMedia;

  tipoCambiado = false;

  ever = true;
  desde_dia;
  desde_hora;
  hasta_dia;
  hasta_hora;

  horarios = [
    {id: 1, titulo: 'Siempre'},
    {id: 2, titulo: 'Dias'},
    {id: 3, titulo: 'Horas'}
  ];

  diasSemana = [
    {id: 1, inicial: 'L', nombre: 'Lunes'},
    {id: 2, inicial: 'M', nombre: 'Martes'},
    {id: 3, inicial: 'M', nombre: 'Miércoles'},
    {id: 4, inicial: 'J', nombre: 'Jueves'},
    {id: 5, inicial: 'V', nombre: 'Viernes'},
    {id: 6, inicial: 'S', nombre: 'Sábado'},
    {id: 7, inicial: 'D', nombre: 'Domingo'}
  ];
  diasSelected = [1, 2, 3, 4, 5, 6, 7];
  url;
  api_url;

  loadingImg = true;
  showframe = false;

  // Entitlement gate (contratos-congelados Slice D2): franja time controls only.
  // Template/control-enable layer; frame edit passthrough below is untouched.
  franjasAllowed$: Observable<boolean>;


  constructor(config: NgbDropdownConfig, private api: Api, private spinner: NgxSpinnerService, private auth: Auth,
              private entitlement: EntitlementService) {
    config.autoClose = true;
    this.franjasAllowed$ = this.entitlement.hasFeature$('franjasHorarias');
  }

  ngOnInit() {
    console.log('construir');
    this.auth.userCheck(() => {
      this.circuito = this.auth.circuito;
      this.api_url = this.api.url;
      console.log(this.frame);
      this.url = this.api_url + '/handler/media/' + this.circuito.guid + '/' + this.frame.path.replace(/(_slot(?:_\d+)?)_[a-f0-9]{8}(?=\.[^.]+$)/, '$1');
      this.newFrame_nombre = this.frame.nombre;
      this.newFrame_texto = (this.frame.tipo === 'noticia' || this.frame.tipo === 'news-frame') ? this.frame.nombre : '';
      this.newFrame_segundos = this.frame.segundos;
      this.newFrame_idMedia = this.frame.idMedia;
      this.desde_dia = this.frame.desde_fecha ? this.frame.desde_fecha : null;
      this.desde_hora = this.frame.desde_hora ? this.frame.desde_hora : null;
      this.hasta_dia = this.frame.hasta_fecha ? this.frame.hasta_fecha : null;
      this.hasta_hora = this.frame.hasta_hora ? this.frame.hasta_hora : null;
      this.diasSelected = (this.frame.dias && this.frame.dias.length)
        ? this.frame.dias.slice() : [1, 2, 3, 4, 5, 6, 7];
      console.log(this.frame.tipo);
      types.forEach((type) => {
        if (type.type === this.frame.tipo) {
          this.newFrame_idTipo = type;
        }
      });
      this.showframe = true;
    }, err => {
      this.auth.logout();
    });
  }

  GuardarCambios() {
    this.onclose.emit();
  }

  formatDate(date) {
    console.log(date);
    const _date = moment(date).format('YYYY-MM-DD');
    console.log(_date);
    return _date;
  }

  createFrame() {
    console.log('Crear frame');
    const frame = Object.assign({}, this.frame);
    if (this.newFrame_idTipo && (this.newFrame_idTipo.type === 'noticia' || this.newFrame_idTipo.type === 'news-frame')) {
      frame.nombre = this.newFrame_texto;
    } else {
      frame.nombre = this.newFrame_nombre;
    }
    frame.idMedia = this.newFrame_idMedia;
    frame.segundos = this.newFrame_segundos;
    frame.desde_fecha = this.desde_dia ? this.formatDate(this.desde_dia) : null;
    frame.desde_hora = this.desde_hora ? this.desde_hora : null;
    frame.hasta_fecha = this.hasta_dia ? this.formatDate(this.hasta_dia) : null;
    frame.hasta_hora = this.hasta_hora ? this.hasta_hora : null;
    frame.dias = this.diasSelected.slice();
    if (this.tipoCambiado && this.newFrame_idTipo) {
      frame.idTipo = this.newFrame_idTipo.id;
      frame.tipo = this.newFrame_idTipo.type;
    }
    this.save.emit(frame);
    console.log(frame);
  }

  close() {
    this.onclose.emit();
  }

  selectTipo(tipo) {
    this.newFrame_idTipo = tipo;
    this.tipoCambiado = true;
    console.log(this.newFrame_idTipo);
  }

  toggleDia(dia) {
    const idx = this.diasSelected.indexOf(dia.id);
    if (idx >= 0) {
      this.diasSelected.splice(idx, 1);
    } else {
      this.diasSelected.push(dia.id);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/frame-view/frame-view.component.ts